// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ConfirmPhoneDTOAPIModel,
    ConfirmPhoneDTOAPIModelFromJSON,
    ConfirmPhoneDTOAPIModelToJSON,
    ConfirmPhoneResponseDTOAPIModel,
    ConfirmPhoneResponseDTOAPIModelFromJSON,
    ConfirmPhoneResponseDTOAPIModelToJSON,
    UpdatePhoneDTOAPIModel,
    UpdatePhoneDTOAPIModelFromJSON,
    UpdatePhoneDTOAPIModelToJSON,
    UpdatePhoneResponseDTOAPIModel,
    UpdatePhoneResponseDTOAPIModelFromJSON,
    UpdatePhoneResponseDTOAPIModelToJSON,
} from '../models';

export interface VerificationControllerUpdateRequest {
    updatePhoneDTOAPIModel: UpdatePhoneDTOAPIModel;
}

export interface VerificationControllerVerifyPhoneRequest {
    confirmPhoneDTOAPIModel: ConfirmPhoneDTOAPIModel;
}

/**
 * VerificationApi - interface
 * 
 * @export
 * @interface VerificationApiInterface
 */
export interface VerificationApiInterface {
    /**
     * 
     * @param {UpdatePhoneDTOAPIModel} updatePhoneDTOAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    verificationControllerUpdateRaw(requestParameters: VerificationControllerUpdateRequest): Promise<runtime.ApiResponse<UpdatePhoneResponseDTOAPIModel>>;

    /**
     */
    verificationControllerUpdate(updatePhoneDTOAPIModel: UpdatePhoneDTOAPIModel): Promise<UpdatePhoneResponseDTOAPIModel>;

    /**
     * 
     * @param {ConfirmPhoneDTOAPIModel} confirmPhoneDTOAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApiInterface
     */
    verificationControllerVerifyPhoneRaw(requestParameters: VerificationControllerVerifyPhoneRequest): Promise<runtime.ApiResponse<ConfirmPhoneResponseDTOAPIModel>>;

    /**
     */
    verificationControllerVerifyPhone(confirmPhoneDTOAPIModel: ConfirmPhoneDTOAPIModel): Promise<ConfirmPhoneResponseDTOAPIModel>;

}

/**
 * 
 */
export class VerificationApi extends runtime.BaseAPI implements VerificationApiInterface {

    /**
     */
    async verificationControllerUpdateRaw(requestParameters: VerificationControllerUpdateRequest): Promise<runtime.ApiResponse<UpdatePhoneResponseDTOAPIModel>> {
        if (requestParameters.updatePhoneDTOAPIModel === null || requestParameters.updatePhoneDTOAPIModel === undefined) {
            throw new runtime.RequiredError('updatePhoneDTOAPIModel','Required parameter requestParameters.updatePhoneDTOAPIModel was null or undefined when calling verificationControllerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/verification/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePhoneDTOAPIModelToJSON(requestParameters.updatePhoneDTOAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePhoneResponseDTOAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async verificationControllerUpdate(updatePhoneDTOAPIModel: UpdatePhoneDTOAPIModel): Promise<UpdatePhoneResponseDTOAPIModel> {
        const response = await this.verificationControllerUpdateRaw({ updatePhoneDTOAPIModel: updatePhoneDTOAPIModel });
        return await response.value();
    }

    /**
     */
    async verificationControllerVerifyPhoneRaw(requestParameters: VerificationControllerVerifyPhoneRequest): Promise<runtime.ApiResponse<ConfirmPhoneResponseDTOAPIModel>> {
        if (requestParameters.confirmPhoneDTOAPIModel === null || requestParameters.confirmPhoneDTOAPIModel === undefined) {
            throw new runtime.RequiredError('confirmPhoneDTOAPIModel','Required parameter requestParameters.confirmPhoneDTOAPIModel was null or undefined when calling verificationControllerVerifyPhone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/verification/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmPhoneDTOAPIModelToJSON(requestParameters.confirmPhoneDTOAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfirmPhoneResponseDTOAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async verificationControllerVerifyPhone(confirmPhoneDTOAPIModel: ConfirmPhoneDTOAPIModel): Promise<ConfirmPhoneResponseDTOAPIModel> {
        const response = await this.verificationControllerVerifyPhoneRaw({ confirmPhoneDTOAPIModel: confirmPhoneDTOAPIModel });
        return await response.value();
    }

}
